import { queryOptions, useQuery } from '@tanstack/react-query';
import { BeltDTO, BeltObservationService, DateRangeDTO } from '../generated';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';

const beltObservationsKeys = {
  base: () => ['beltObservations'] as const,
  one: ({ jobsiteId, dateRange }: BeltObservationsOptiosProps) =>
    [...beltObservationsKeys.base(), jobsiteId, dateRange] as const,
};

interface BeltObservationsOptiosProps {
  jobsiteId: string | undefined;
  dateRange: DateRangeDTO;
}

function beltObservationsOptions({ jobsiteId, dateRange }: BeltObservationsOptiosProps) {
  return queryOptions<BeltDTO[], ApiError>({
    queryKey: beltObservationsKeys.one({ jobsiteId, dateRange }),
    queryFn: async () => {
      if (!jobsiteId || !dateRange) throw new Error('jobsiteId and dateRange are required');

      const response = await BeltObservationService.beltControllerGetBeltObservations({
        path: { jobsiteId },
        query: { observedAt: dateRange, limit: 1000 },
      });

      if (response.data != undefined) {
        return response.data;
      }

      throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
    },
    enabled: !!jobsiteId && !!dateRange,
  });
}

export function useBeltObservations(props: BeltObservationsOptiosProps) {
  return useQuery(beltObservationsOptions(props));
}
